(function(){
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
  if (reduceMotion || !hasFinePointer) return; // skip on touch/mobile + accessibility opt-outs

  const canvas = document.createElement('canvas');
  canvas.id = 'oud-mist-canvas';
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  let dpr;

  function resize(){
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width  = window.innerWidth  * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width  = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  window.addEventListener('resize', resize);
  resize();

  let particles = [];
  let lastX = null, lastY = null, lastSpawn = 0;

  const GOLD_TONES = window.OUD_MIST_PALETTE || [[201,162,75],[230,200,119],[243,234,217]]; // swap to your palette if needed

  function spawn(x, y, speed){
    const tone = GOLD_TONES[Math.floor(Math.random()*GOLD_TONES.length)];
    const count = Math.min(3, 1 + Math.floor(speed / 18));
    for(let i=0;i<count;i++){
      particles.push({
        x: x + (Math.random()-0.5)*6, y: y + (Math.random()-0.5)*6,
        vx: (Math.random()-0.5)*0.35, vy: -0.25 - Math.random()*0.35,
        size: 3 + Math.random()*4, maxSize: 16 + Math.random()*18,
        life: 0, maxLife: 1600 + Math.random()*900,
        color: tone, sway: Math.random()*Math.PI*2, swaySpeed: 0.01 + Math.random()*0.015
      });
    }
  }

  window.addEventListener('mousemove', (e)=>{
    if(lastX !== null){
      const dx = e.clientX-lastX, dy = e.clientY-lastY;
      const dist = Math.sqrt(dx*dx+dy*dy);
      const now = performance.now();
      if(dist > 2 && now - lastSpawn > 16){ spawn(e.clientX, e.clientY, dist); lastSpawn = now; }
    }
    lastX = e.clientX; lastY = e.clientY;
  });

  let prevT = performance.now();
  function tick(t){
    const dt = t - prevT; prevT = t;
    ctx.clearRect(0,0,window.innerWidth, window.innerHeight);
    particles.forEach(p=>{
      p.life += dt; p.sway += p.swaySpeed*dt;
      p.x += p.vx*dt*0.05 + Math.sin(p.sway)*0.06;
      p.y += p.vy*dt*0.05;
      const progress = p.life / p.maxLife;
      const size = p.size + (p.maxSize - p.size)*progress;
      const alpha = Math.max(0, 0.55 * (1-progress) * (1-progress));
      const g = ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,size);
      const [r,gr,b] = p.color;
      g.addColorStop(0, `rgba(${r},${gr},${b},${alpha})`);
      g.addColorStop(1, `rgba(${r},${gr},${b},0)`);
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(p.x,p.y,size,0,Math.PI*2); ctx.fill();
    });
    particles = particles.filter(p=>p.life < p.maxLife);
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();